'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dRestricted$002dDomain$002dName$0024$0024anon$0024149 from "./presto.types$-Restricted-Domain-Name$$anon$149.js";
import * as $j_presto$002etypes$0024$002dRestricted$002dDomain$002dName$0024$0024anon$0024150 from "./presto.types$-Restricted-Domain-Name$$anon$150.js";
var $p;
/** @constructor */
function $c_Lpresto_types$RestrictedDomainName$() {
  this.c8T = null;
  this.c8U = false;
  this.c8R = null;
  this.c8S = false;
  this.c8X = null;
  this.c8Y = false;
  this.c8V = null;
  this.c8W = false;
  this.c8Z = null;
  this.c90 = false;
}
export { $c_Lpresto_types$RestrictedDomainName$ as $c_Lpresto_types$RestrictedDomainName$ };
$p = $c_Lpresto_types$RestrictedDomainName$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$RestrictedDomainName$;
/** @constructor */
function $h_Lpresto_types$RestrictedDomainName$() {
}
export { $h_Lpresto_types$RestrictedDomainName$ as $h_Lpresto_types$RestrictedDomainName$ };
$h_Lpresto_types$RestrictedDomainName$.prototype = $p;
$p.cIc = (function() {
  if ((!this.c8U)) {
    this.c8T = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().aD;
    this.c8U = true;
  }
  return this.c8T;
});
$p.SL = (function() {
  if ((!this.c8S)) {
    this.c8R = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().aa;
    this.c8S = true;
  }
  return this.c8R;
});
$p.adE = (function() {
  if ((!this.c8Y)) {
    this.c8X = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lcom_raquo_laminar_modifiers_RenderableText$$anon$1(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((x) => x)), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_laminar_modifiers_RenderableText$());
    this.c8Y = true;
  }
  return this.c8X;
});
$p.cIz = (function() {
  if ((!this.c8W)) {
    this.c8V = new $j_presto$002etypes$0024$002dRestricted$002dDomain$002dName$0024$0024anon$0024149.$c_Lpresto_types$RestrictedDomainName$$anon$149(this);
    this.c8W = true;
  }
  return this.c8V;
});
$p.cJ5 = (function() {
  if ((!this.c90)) {
    this.c8Z = new $j_presto$002etypes$0024$002dRestricted$002dDomain$002dName$0024$0024anon$0024150.$c_Lpresto_types$RestrictedDomainName$$anon$150(this);
    this.c90 = true;
  }
  return this.c8Z;
});
var $d_Lpresto_types$RestrictedDomainName$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$RestrictedDomainName$, "presto.types$RestrictedDomainName$", ({
  a0X: 1,
  D: 1
}));
export { $d_Lpresto_types$RestrictedDomainName$ as $d_Lpresto_types$RestrictedDomainName$ };
var $n_Lpresto_types$RestrictedDomainName$;
function $m_Lpresto_types$RestrictedDomainName$() {
  if ((!$n_Lpresto_types$RestrictedDomainName$)) {
    $n_Lpresto_types$RestrictedDomainName$ = new $c_Lpresto_types$RestrictedDomainName$();
  }
  return $n_Lpresto_types$RestrictedDomainName$;
}
export { $m_Lpresto_types$RestrictedDomainName$ as $m_Lpresto_types$RestrictedDomainName$ };
//# sourceMappingURL=presto.types$-Restricted-Domain-Name$.js.map
